/**
 * How one collection item is named. A LinkedIn post has no title, so its
 * opening line names it: the first line of `body`, which is also the line a
 * reader sees before "see more".
 *
 * Aliases: post title, post opening line, collection item title
 */

import type { JsonValue } from "~/lib/shared/json";

export function postOpeningLine(
  data: Record<string, JsonValue>,
): string | null {
  const body = data.body;
  if (typeof body !== "string") return null;
  return (
    body
      .split("\n")
      .map((line) => line.trim())
      .find((line) => line.length > 0) ?? null
  );
}

/** Cuts `text` to `max` characters at a word boundary, with an ellipsis. */
export function truncateTitle(text: string, max: number): string {
  if (text.length <= max) return text;
  const cut = text.slice(0, max - 1);
  const lastSpace = cut.lastIndexOf(" ");
  return `${(lastSpace > max / 2 ? cut.slice(0, lastSpace) : cut).trimEnd()}…`;
}
